import { ProjectPropertyType } from 'src/constants/project';
import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const updateModelPropertyTypeIris =
  (prevIri: string, newIri: string) => (model: Model) => {
    const propertyTypesByIri = Object.entries(
      model.modelData.propertyTypesByIri
    ).reduce<Record<string, ProjectPropertyType>>(
      (acc, [prevTypeIri, prevType]) => {
        const iri = prevTypeIri === prevIri ? newIri : prevTypeIri;
        acc[iri] = prevType;
        return acc;
      },
      {}
    );
    setDataProperty<ModelData>(model)(
      model.modelData,
      'propertyTypesByIri',
      propertyTypesByIri
    );
  };
